"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typography = void 0;
/**
 * Default font settings.
 */

var fontSettings = "\n  margin: 0;\n\n  font-feature-settings: 'calt', 'clig', 'kern', 'liga', 'locl', 'rlig';\n  -webkit-font-feature-settings: 'calt', 'clig', 'kern', 'liga', 'locl', 'rlig';\n";
/**
 * Export `typography`.
 */

var typography = {
  fontSettings: fontSettings
};
exports.typography = typography;